import React from 'react';
import usePageMeta from '../hooks/usePageMeta';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import WhyChooseUs from '../components/WhyChooseUs';
import HowToWork from '../components/HowToWork';
import TechnicalSolutions from '../components/TechnicalSolutions';
import OurWorks from '../components/OurWorks';
import Testimonials from '../components/Testimonials';
import NewsAndFAQ from '../components/NewsAndFAQ';
import BottomSections from '../components/BottomSections';

export default function HomePage() {
    usePageMeta(
        'Bliv Design Studio | Leading End‑to‑End Home Interior Designers in South India',
        'Bliv Design Studio delivers turnkey home interiors across South India. Modular kitchens, wardrobes, false ceilings, and complete MEP‑backed design from concept to handover.'
    );

    return (
        <>
            <HeroSection />
            <ServicesSection />
            <WhyChooseUs />
            <HowToWork />
            <TechnicalSolutions />
            <OurWorks />
            <Testimonials />
            <NewsAndFAQ />
            <BottomSections />
        </>
    );
}
